import { Routes } from "@angular/router";

export const routes: Routes = [
  { path: "", redirectTo: "/auth/login", pathMatch: "full" },
  {
    path: "auth",
    loadChildren: () =>
      import("./features/auth/auth.routes").then((m) => m.AuthRouteModule),
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./features/dashboard/dashboard.routes").then(
        (m) => m.DashboardRouteModule
      ),
  },
  {
    path: "settings",
    loadChildren: () =>
      import("./features/settings/settings.route").then(
        (m) => m.SettingsRouteModule
      ),
  },
  { path: "**", redirectTo: "/auth/login" },
];
